export default __webpack_public_path__ + "static/media/Wolf Tamer's Cloak.d9f9e72f.jpg";